<app-sp-page-error
  title="This link has expired or is no longer valid."
  subtitle="Please contact the person who shared this link to request an updated version."
  [showActionButton]="false"
  [imageType]="ImageType.NOT_FOUND">
</app-sp-page-error>
